import React, { createContext, useContext, useMemo } from "react";
import { useLocation } from "react-router-dom";
import mx from "@/locales/mx.json";
import en from "@/locales/en.json";

const DICTIONARIES = { mx, en };

const I18nContext = createContext({
  lang: "mx",
  dict: mx,
  t: (key) => key,
});

/**
 * Reads the current language from the URL prefix (/mx, /en).
 * Defaults to Spanish ("mx"). The /thank_you route is forced to Spanish
 * as required by the spec.
 */
export const getLangFromPath = (pathname) => {
  if (!pathname) return "mx";
  if (pathname === "/thank_you" || pathname.startsWith("/thank_you"))
    return "mx";
  if (pathname === "/en" || pathname.startsWith("/en/") || pathname === "/en")
    return "en";
  if (pathname === "/mx" || pathname.startsWith("/mx/")) return "mx";
  return "mx";
};

const resolve = (dict, key) => {
  const parts = key.split(".");
  let node = dict;
  for (const p of parts) {
    if (node && typeof node === "object" && p in node) {
      node = node[p];
    } else {
      return key;
    }
  }
  return typeof node === "string" ? node : key;
};

export const I18nProvider = ({ children }) => {
  const { pathname } = useLocation();
  const lang = getLangFromPath(pathname);
  const dict = DICTIONARIES[lang] || DICTIONARIES.mx;

  const value = useMemo(
    () => ({
      lang,
      dict,
      t: (key) => resolve(dict, key),
    }),
    [lang, dict],
  );

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
};

export const useI18n = () => useContext(I18nContext);
